import { http } from '@packet/management/src/api/http';
import type { CreateUserRequest, UpdateUserRequest, GetUserListRequest, GetUserListResponse, GetUserDetailRequest, GetUserDetailResponse, DeleteUserRequest } from '../../DTO/user';
import type { ApiResponse } from '../../DTO/common';

/**
 * 获取用户列表
 */
export const getUserList = async (params: GetUserListRequest): Promise<ApiResponse<GetUserListResponse>> => {
  return http().get('/api/v1/users/list', params);
};

/**
 * 创建用户
 */
export const createUser = async (data: CreateUserRequest): Promise<ApiResponse<null>> => {
  return http().post('/api/v1/users/create', data);
};

/**
 * 更新用户
 */
export const updateUser = async (data: UpdateUserRequest): Promise<ApiResponse<null>> => {
  return http().put('/api/v1/users/update', data);
};

/**
 * 删除用户
 */
export const deleteUser = async (params: DeleteUserRequest): Promise<ApiResponse<null>> => {
  return http().del(`/api/v1/users/delete?id=${params.id}`);
};

/**
 * 获取用户详情
 */
export const getUserDetail = async (params: GetUserDetailRequest): Promise<ApiResponse<GetUserDetailResponse>> => {
  return http().get('/api/v1/users/get', params);
};
